import { useEffect } from "react"
import { safeRender, type RootEntry } from "./shadowPortal"
import type { MutableRefObject, ReactNode } from "react"

// Declaratively keeps the shadow-DOM root held in `entryRef` in sync with `element`. The root is
// created elsewhere (an Apryse `addPanel` render callback, or `createOverlayContainers`); this hook
// only (re)paints it. It re-renders on every host render — React reconciliation bails out when the
// element's props are unchanged — so callers compute `element` from live state/props with NO manual
// dependency array. That hand-maintained dep list is exactly what the old imperative render effects
// carried, and it is the thing that goes stale when a dependency is missed. Pass `null` to clear the
// subtree. When `visible` is supplied it also toggles the container's `display`, for overlays whose
// wrapper is shown/hidden (rather than unmounted).
export const useShadowMount = (
	entryRef: MutableRefObject<RootEntry | null>,
	element: ReactNode,
	visible?: boolean,
) => {
	useEffect(() => {
		const entry = entryRef.current
		if (entry && visible !== undefined) {
			entry.container.style.display = visible ? "block" : "none"
		}
		safeRender(entryRef, element)
	})
}
